export default __webpack_public_path__ + "static/media/auto-activation.1a26c44d.svg";